import { IconFont, UpLoadFile, SvgIcon } from '@/components'
import { Message } from '@/components/message'
import { ShowTotal } from '@/components/show-total'
import { Dispaths } from '@/types'
import { useSelections } from 'ahooks'
import { Button, Card, message, Radio, Steps, Table, Typography } from 'antd'
import { useContext, useEffect, useState } from 'react'
import styled from 'styled-components'
import { useLoadscv } from './utils'
import { t } from '@/i18n'
const { Step } = Steps
interface CreateTaskContextValue {
  data: {
    steps: number
    dataList: any
    updata: any
    id: string
  }
  dispatch: {
    setSteps: Dispaths<number>
    setUpdata: Dispaths<any>
    cancel: (data) => void
  }
}
const Analyses = () => {
  const columns = [
    {
      width: '70%',
      title: t('CSV邮箱'),
      dataIndex: 'email',
    },
    {
      width: '30%',
      title: t('CSV姓名'),
      dataIndex: 'name',
      render: text => (
        <Typography.Text ellipsis={{ tooltip: true }} style={{ maxWidth: 400 }}>
          {text}
        </Typography.Text>
      ),
    },
  ]

  const alteration = [
    {
      title: t('邮箱'),
      dataIndex: 'email',
      width: 200,
    },
    {
      width: 300,
      title: (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            marginRight: '30px',
          }}
        >
          <p>{t('原姓名')}</p>
          <IconFont type={'icon-cs-jt-xy-1-1'} style={{ fontSize: '26px' }} />
          <p style={{ width: '40%', textAlign: 'left' }}>{t('CSV姓名')}</p>
        </div>
      ),

      dataIndex: 'name',
      render: (text, data) => (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            marginRight: '30px',
          }}
        >
          <p className="text">{data.old_name || '-'}</p>
          <p className="text" style={{ textAlign: 'left' }}>
            {text}
          </p>
        </div>
      ),
    },
    {
      title: '',
      width: 150,
    },
    {
      width: 300,
      title: (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            marginRight: '30px',
          }}
        >
          <p>{t('原部门')}</p>
          <IconFont type={'icon-cs-jt-xy-1-1'} style={{ fontSize: '26px' }} />
          <p>{t('CSV部门')}</p>
        </div>
      ),

      dataIndex: 'group_name',
      render: (text, data) => (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            marginRight: '30px',
          }}
        >
          <p>{data.old_group_name}</p>
          <p>{text}</p>
        </div>
      ),
    },
  ]

  const gorupColumns = [
    {
      title: t('邮箱'),
      width: '70%',
      dataIndex: 'email',
    },
    {
      width: '30%',
      title: t('姓名'),
      dataIndex: 'name',
      render: text => (
        <Typography.Text ellipsis={{ tooltip: true }} style={{ maxWidth: 400 }}>
          {text}
        </Typography.Text>
      ),
    },
  ]

  const wrongData = [
    {
      width: '70%',
      title: t('CSV邮箱'),
      dataIndex: 'email',
    },
    {
      width: '30%',
      title: t('CSV姓名'),
      dataIndex: 'name',
      render: text => (
        <Typography.Text ellipsis={{ tooltip: true }} style={{ maxWidth: 400 }}>
          {text}
        </Typography.Text>
      ),
    },
  ]

  const [loadscv] = useLoadscv()
  const { dispatch, data } = useCreateTaskContext()
  let [add, setAdd] = useState(1)
  let [del, setDel] = useState(1)
  let [update, setUpdate] = useState(1)
  let [delList, setDelList] = useState<any>()

  const tableToExcel = () => {
    // 列标题，逗号隔开，每一个逗号就是隔开一个单元格
    let str = 'CSV姓名,CSV邮箱,\tCSV部门\n'
    // 增加\t为了不让表格显示科学计数法或者其他格式
    for (let i = 0; i < data?.dataList?.err?.length; i++) {
      for (const key in data?.dataList?.err[i]) {
        if (key !== 'id') {
          str += `${`${data?.dataList?.err[i][key]}\t`},`
        }
      }
      str += '\n'
    }
    // encodeURIComponent解决中文乱码
    // eslint-disable-next-line prefer-template
    const uri = 'data:text/csv;charset=utf-8,\ufeff' + encodeURIComponent(str)
    // 通过创建a标签实现
    const link = document.createElement('a')
    link.href = uri
    // 对下载的文件命名
    link.download = t('错误数据.csv')
    link.click()
  }
  const updateCsv = () => {
    // 列标题，逗号隔开，每一个逗号就是隔开一个单元格
    let str = '邮箱,CSV姓名,组名称姓名,\tCSV部门,组名称部门\n'
    // 增加\t为了不让表格显示科学计数法或者其他格式
    for (let i = 0; i < data?.dataList?.update?.length; i++) {
      for (const key in data?.dataList?.update[i]) {
        if (key !== 'id') {
          str += `${`${data?.dataList?.update[i][key]}\t`},`
        }
      }
      str += '\n'
    }
    // encodeURIComponent解决中文乱码
    // eslint-disable-next-line prefer-template
    const uri = 'data:text/csv;charset=utf-8,\ufeff' + encodeURIComponent(str)
    // 通过创建a标签实现
    const link = document.createElement('a')
    link.href = uri
    // 对下载的文件命名
    link.download = t('变更数据.csv')
    link.click()
  }
  const { isSelected, toggle, selected } = useSelections(['add', 'change', 'del', 'err', 'repeat'])

  return (
    <div className="step-one">
      <CardTask
        title={
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Steps style={{ width: '50%' }}>
              <Step
                title={t('批量导入')}
                icon={
                  <div className="step-list">
                    <IconFont style={{ color: '#4238C9' }} type={'icon-piliangdaoru'} />
                  </div>
                }
              />

              <Step
                title={t('导入数据分析')}
                icon={
                  <div className="step-list">
                    <SvgIcon name={'analysis_complete'} style={{ width: '24px', height: '24px' }} />
                  </div>
                }
              />

              <Step
                title={t('导入结果')}
                icon={
                  <div className="step-list">
                    <SvgIcon name={'result'} style={{ width: '24px', height: '24px' }} />
                  </div>
                }
              />
            </Steps>
          </div>
        }
        actions={[
          <div className="footer">
            <Button onClick={() => dispatch.cancel(false)}>{t('取消')}</Button>
            <Button
              style={{ margin: '0 10px' }}
              onClick={() => dispatch.setSteps(origin => origin - 1)}
            >
              {t('上一步')}
            </Button>
            <Button
              type={'primary'}
              onClick={() => {
                loadscv({
                  group_id: data.id,
                  del: del === 2 ? data?.dataList?.del.map(item => item.id) : [],
                  update: update === 1 ? data?.dataList?.update || [] : [],
                  add: add === 1 ? data?.dataList?.add || [] : [],
                })
                  .then(res => {
                    dispatch.setUpdata(origin => ({
                      ...origin,
                      del: del === 2 ? delList : [],
                      update: update === 1 ? data?.dataList?.update || [] : [],
                      add: add === 1 ? data?.dataList?.add || [] : [],
                      result: 1,
                    }))
                    dispatch.setSteps(3)
                  })
                  .catch(err => {
                    dispatch.setUpdata(origin => ({
                      ...origin,
                      del: del === 2 ? delList : [],
                      update: update === 1 ? data?.dataList?.update || [] : [],
                      add: add === 1 ? data?.dataList?.add || [] : [],
                      result: 0,
                    }))
                    dispatch.setSteps(3)
                  })
              }}
            >
              {t('下一步')}
            </Button>
          </div>,
        ]}
      >
        <div style={{ width: '100%', padding: '0 20px' }}>
          <div>
            <div
              style={{
                marginBottom: '16px',
                display: 'flex',
                alignItems: 'center',
                paddingBottom: 12,
                borderBottom: '1px solid #EAEDF1',
                justifyContent: 'space-between',
              }}
            >
              <div className="flex">
                <p style={{ height: 12 }}>
                  {t('新增数据（')}
                  <span style={{ color: '#558492' }}>{data?.dataList?.add?.length || 0}</span>
                  {t('条）')}
                </p>
                <Radio.Group onChange={e => setAdd((add = e.target.value))} defaultValue={add}>
                  <Radio value={1}>{t('插入')}</Radio>
                  <Radio value={2}>{t('忽略')}</Radio>
                </Radio.Group>
              </div>
              <Icon
                type="icon-show_zhediezhankai_xiangshang"
                selected={isSelected('add')}
                onClick={() => {
                  toggle('add')
                }}
              />
            </div>
            <Table
              style={{ display: !isSelected('add') && 'none' }}
              columns={columns}
              dataSource={data?.dataList?.add}
              pagination={{
                total: data?.dataList?.add?.length,
                showTotal: total => <ShowTotal>{total}</ShowTotal>,
                showSizeChanger: true,
                showQuickJumper: true,
                pageSizeOptions: ['10', '20', '50', '100'],
              }}
              // rowKey={(record: any) => record.id}
            />
          </div>
          <div>
            <div
              style={{
                marginBottom: '16px',
                display: 'flex',
                justifyContent: 'space-between',
                marginTop: 17,
                paddingBottom: 12,
                borderBottom: '1px solid #EAEDF1',
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <p style={{ height: 12 }}>
                  {t('变更数据（')}
                  <span style={{ color: '#558492' }}>{data?.dataList?.update?.length || 0}</span>
                  {t('条）')}
                </p>

                <Radio.Group
                  onChange={e => setUpdate((update = e.target.value))}
                  defaultValue={update}
                >
                  <Radio value={1}>{t('覆盖')}</Radio>
                  <Radio value={2}>{t('不导入')}</Radio>
                </Radio.Group>
              </div>

              <div className="flex">
                <div
                  onClick={() => {
                    updateCsv()
                  }}
                  style={{ color: '#4238C9', cursor: 'pointer' }}
                >
                  <IconFont type={'icon-xiazai2'} />
                  {t('下载')}
                </div>
                <Icon
                  type="icon-show_zhediezhankai_xiangshang"
                  selected={isSelected('change')}
                  onClick={() => toggle('change')}
                />
              </div>
            </div>
            <Table
              style={{ display: !isSelected('change') && 'none' }}
              columns={alteration}
              dataSource={data?.dataList?.update}
              rowKey={(record: any) => record.id}
              // pagination={false}
              pagination={{
                total: data?.dataList?.update?.length,
                showTotal: total => <ShowTotal>{total}</ShowTotal>,
                showSizeChanger: true,
                showQuickJumper: true,
                pageSizeOptions: ['10', '20', '50', '100'],
              }}
            />
          </div>
          <div>
            <div
              style={{
                marginBottom: '16px',
                display: 'flex',
                marginTop: 17,
                alignItems: 'center',
                paddingBottom: 12,
                borderBottom: '1px solid #EAEDF1',
                justifyContent: 'space-between',
              }}
            >
              <div className="flex">
                <p>
                  {t('减少数据（')}
                  <span style={{ color: '#558492' }}>{data?.dataList?.del?.length || 0}</span>
                  {t('条）')}
                </p>
                <Radio.Group
                  onChange={e => {
                    setDel((del = e.target.value))
                    let arr = []
                    if (del === 2) {
                      data?.dataList?.del?.forEach(item => {
                        arr.push(item.id)
                      })
                    }
                    setDelList((delList = arr))
                  }}
                  defaultValue={del}
                >
                  <Radio value={1}>{t('忽略')}</Radio>
                  <Radio value={2}>{t('删除')}</Radio>
                </Radio.Group>
              </div>
              <Icon
                type="icon-show_zhediezhankai_xiangshang"
                selected={isSelected('del')}
                onClick={() => toggle('del')}
              />
            </div>
            <Table
              style={{ display: !isSelected('del') && 'none' }}
              columns={gorupColumns}
              dataSource={data?.dataList?.del}
              rowKey={(record: any) => record.id}
              // pagination={false}
              pagination={{
                total: data?.dataList?.del?.length,
                showTotal: total => <ShowTotal>{total}</ShowTotal>,
                showSizeChanger: true,
                showQuickJumper: true,
                pageSizeOptions: ['10', '20', '50', '100'],
              }}
            />
          </div>
          <div>
            <div
              style={{
                marginBottom: '16px',
                display: 'flex',
                justifyContent: 'space-between',
                marginTop: 17,
                paddingBottom: 12,
                borderBottom: '1px solid #EAEDF1',
              }}
            >
              <p>
                {t('错误数据（')}
                <span style={{ color: '#558492' }}>{data?.dataList?.err?.length || 0}</span>
                {t('条）')}
              </p>
              <div className="flex">
                <div
                  onClick={() => {
                    tableToExcel()
                  }}
                  style={{ color: '#4238C9', cursor: 'pointer' }}
                >
                  <IconFont type={'icon-xiazai2'} />
                  {t('下载')}
                </div>
                <Icon
                  type="icon-show_zhediezhankai_xiangshang"
                  selected={isSelected('err')}
                  onClick={() => toggle('err')}
                />
              </div>
            </div>
            <Table
              columns={wrongData}
              style={{ display: !isSelected('err') && 'none' }}
              // pagination={false}
              pagination={{
                total: data?.dataList?.err?.length,
                showTotal: total => <ShowTotal>{total}</ShowTotal>,
                showSizeChanger: true,
                showQuickJumper: true,
                pageSizeOptions: ['10', '20', '50', '100'],
              }}
              dataSource={data?.dataList?.err}
              rowKey={(record: any) => record.id}
            />
          </div>
          <div>
            <div
              style={{
                marginBottom: '16px',
                display: 'flex',
                marginTop: 17,
                paddingBottom: 12,
                borderBottom: '1px solid #EAEDF1',
                justifyContent: 'space-between',
              }}
            >
              <p>
                {t('重复数据（')}
                <span style={{ color: '#558492' }}>{data?.dataList?.repeated?.length || 0}</span>
                {t('条）')}
              </p>
              <Icon
                type="icon-show_zhediezhankai_xiangshang"
                selected={isSelected('repeat')}
                onClick={() => toggle('repeat')}
              />
            </div>
            <Table
              columns={wrongData}
              style={{ display: !isSelected('repeat') && 'none' }}
              // pagination={false}
              pagination={{
                total: data?.dataList?.repeated?.length,
                showTotal: total => <ShowTotal>{total}</ShowTotal>,
                showSizeChanger: true,
                showQuickJumper: true,
                pageSizeOptions: ['10', '20', '50', '100'],
              }}
              dataSource={data?.dataList?.repeated}
              rowKey={(record: any) => record.id}
            />
          </div>
        </div>
      </CardTask>
    </div>
  )
}
const ImportData = () => {
  const { dispatch, data } = useCreateTaskContext()
  const [loadscv] = useLoadscv()
  return (
    <div className="step-one">
      <div className="heder">
        <Steps style={{ width: '50%' }}>
          <Step
            title={t('批量导入')}
            icon={
              <div className="step-list">
                <IconFont style={{ color: '#4238C9' }} type={'icon-piliangdaoru'} />
              </div>
            }
          />

          <Step
            title={t('导入数据分析')}
            icon={
              <div className="step-list">
                <SvgIcon name={'analysis_complete'} style={{ width: '24px', height: '24px' }} />
              </div>
            }
          />

          <Step
            title={t('导入结果')}
            icon={
              <div className="step-list">
                <SvgIcon name={'result_complete'} style={{ width: '24px', height: '24px' }} />
              </div>
            }
          />
        </Steps>
      </div>
      {data?.updata?.result === 1 ? (
        <ResultContainer>
          <IconFont type={'icon-chenggong2'} className="icon" />
          <div className="result" style={{ margin: '40px 0' }}>
            {t('导入成功')}
          </div>
          <Button type={'primary'} onClick={() => dispatch.cancel(false)}>
            {t('返回')}
          </Button>
        </ResultContainer>
      ) : (
        <ResultContainer>
          <IconFont type={'icon-cuowu1'} className="icon" />
          <div style={{ margin: '40px 0' }} className="result">
            {t('导入失败')}
          </div>
          <div style={{ display: 'felx' }}>
            <Button onClick={() => dispatch.cancel(false)}>{t('取消')}</Button>
            <Button
              type={'primary'}
              style={{ marginLeft: '10px' }}
              onClick={() => {
                loadscv({
                  group_id: data.id,
                  del: data.updata?.del,
                  update: data.updata.updata,
                  add: data.updata.add,
                })
                  .then(res => {
                    dispatch.setUpdata(origin => ({
                      ...origin,
                      result: 1,
                    }))
                  })
                  .catch(_ => {})
              }}
            >
              {t('重新导入')}
            </Button>
          </div>
        </ResultContainer>
      )}
      <div style={{ width: '100%', paddingBottom: '20px', paddingTop: '16px' }} />
    </div>
  )
}
const useCreateTaskContext = () => {
  const res = useContext(createTaskContext)
  if (res === null) {
    throw new Error(t('应在新建任务弹窗中使用该hook'))
  }
  return res
}
const createTaskContext = React.createContext<CreateTaskContextValue | null>(null)
export const BatchAdd = props => {
  let [dataList, setDataList] = useState()
  const { selectGroup, getEmailList$, cancel, id } = props
  const [steps, setSteps] = useState(1)
  const [updata, setUpdata] = useState<any>(id)
  const [err, setErr] = useState(false)
  let userData
  try {
    userData = JSON.parse(localStorage.getItem('token'))
  } catch (error) {}
  const [uploadCsvLoading, setUploadCsvLoading] = useState(false)

  return (
    <UserContainer>
      {steps === 1 && (
        <CardTask
          className="step-one"
          title={
            <div className="heder">
              <Steps style={{ width: '50%' }}>
                <Step
                  title={t('批量导入')}
                  icon={
                    <div className="step-list">
                      <IconFont style={{ color: '#4238C9' }} type={'icon-piliangdaoru'} />
                    </div>
                  }
                />

                <Step
                  title={t('导入数据分析')}
                  icon={
                    <div className="step-list">
                      <SvgIcon name={'analyse'} style={{ height: '24px', width: '24px' }} />
                    </div>
                  }
                />

                <Step
                  title={t('导入结果')}
                  icon={
                    <div className="step-list">
                      <SvgIcon name={'result'} style={{ height: '24px', width: '24px' }} />
                    </div>
                  }
                />
              </Steps>
            </div>
          }
          actions={[
            <div className="footer">
              <Button onClick={() => cancel(false)}>{t('取消')}</Button>
            </div>,
          ]}
        >
          <div style={{ width: '433px', height: 176 }}>
            <UpLoadFile
              showUploadList={false}
              disabled={uploadCsvLoading}
              className={err && 'err'}
              headers={{
                'user-id': userData.id,
                token: userData.token,
              }}
              action={`${
                process.env.NODE_ENV === 'dev' ? '/api' : ''
              }/portal/verify/phish/contacts/loadcsv`}
              beforeUpload={file => {
                const reg = /\.csv$/
                if (reg.test(file.name)) {
                  return true
                }
                setErr(true)
                Message.error(t('仅支持上传.csv文件'))
                return false
              }}
              onChange={({ file }) => {
                if (file.status === 'uploading') {
                  setUploadCsvLoading(true)
                  return
                }
                if (
                  file.status === 'done' ||
                  file.status === 'error' ||
                  file.status === 'success'
                ) {
                  setUploadCsvLoading(false)
                }
                if (file.status === 'done') {
                  const { code, msg } = file.response
                  if (code === 200) {
                    setErr(false)
                    setDataList(file.response.data)
                    getEmailList$.emit()
                    setSteps(2)
                  } else {
                    setErr(true)
                    Message.error(msg || t('上传失败'))
                  }
                  return
                }
                if (file.status === 'error') {
                  setErr(true)
                  Message.error(t('上传失败'))
                }
              }}
              data={{
                group_id: selectGroup?.id,
              }}
              name={'file_name'}
              maxCount={1}
              text={
                uploadCsvLoading ? (
                  t('上传中,请稍后')
                ) : (
                  <div style={{ color: '#666' }}>
                    <span style={{ color: err ? '#f5222d' : '#666' }}>
                      {t('将授权文件拖拽到此处,或')}
                    </span>
                    <Typography.Link style={{ color: '#4238C9' }}>
                      <u>{t('点击上传')}</u>
                    </Typography.Link>
                    <div style={{ marginTop: 12 }}>{t('支持上传CSV格式（UTF-8、GB2312）')}</div>
                  </div>
                )
              }
            />

            <DonwloadCSV>
              <Typography.Link
                target="_blank"
                href={`${
                  process.env.NODE_ENV === 'dev' ? '/api' : ''
                }/portal/verify/phish/contacts/template`}
              >
                <IconFont style={{ color: '#031A79' }} type="icon-xiangmuwenjianmobanku_mobanku" />
                {t('下载CSV模板')}
              </Typography.Link>
            </DonwloadCSV>
          </div>
        </CardTask>
      )}
      <createTaskContext.Provider
        value={{
          data: {
            steps,
            dataList,
            updata,
            id,
          },
          dispatch: {
            setSteps,
            setUpdata,
            cancel,
          },
        }}
      >
        {steps === 2 && <Analyses />}
        {steps === 3 && <ImportData />}
      </createTaskContext.Provider>
    </UserContainer>
  )
}

const DonwloadCSV = styled.div`
  margin-top: 20px;
`
const UserContainer = styled.div`
  width: 100%;
  min-height: 100%;
  background-color: #fff;
  border-radius: 8px;
  .step-one {
    height: 100%;
    display: flex;
    background-color: #fff;
    flex-wrap: wrap;
    justify-content: center;
    flex-wrap: wrap;
    .text {
      width: 40%;
      overflow: hidden; //溢出隐藏
      white-space: nowrap; //禁止换行
      text-overflow: ellipsis; //...
      line-height: 1.2;
    }
  }
  .flex {
    display: flex;
    align-items: center;
  }
  .step-list {
    width: 48px;
    height: 48px;
    border-radius: 50%;
    background: #f5f5f5;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .ant-steps-item-title {
    line-height: 48px;
    &::after {
      top: 24px;
    }
  }
  .heder {
    width: 100%;
    padding: 40px 0 50px;
    display: flex;
    justify-content: center;
  }
  p {
    margin: 0;
  }
  .err {
    border-color: #f5222d;
    &:hover {
      border-color: #f5222d !important;
    }
  }
`
const CardTask = styled(Card)`
  width: 100%;
  .ant-card-head {
    width: 100%;
  }
  .ant-card-body {
    display: flex;
    justify-content: center;
    min-height: 300px;
  }
  .ant-card-actions {
    width: 100%;
  }
  .footer {
    display: flex;
    justify-content: flex-end;
    margin-right: 20px;
  }
  .ant-radio-input:focus + .ant-radio-inner {
    box-shadow: unset;
  }
  .err {
    border-color: #f5222d;
  }
`
const ResultContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 10px;
  .icon {
    font-size: 54px;
  }
  .result {
    margin: 5px 0;
    margin-top: 10px;
    font-size: 24px;
    font-family: 500;
  }
  .text {
    color: #666;
    line-height: 1.2;
  }
`
const Icon = styled(IconFont)`
  font-size: 16px;
  color: #4238c9;
  margin-left: 20px;
  transform: ${props => (props.selected ? 'rotateZ(180deg)' : 'rotateZ(0deg)')};
  transition: all 0.3s;
`
